import { gql } from '@apollo/client';

export const SERIAL_BLOCKS = gql`
  query SerialBlocks (
    $limit: Int!
    $offset: String!
    $options: ConnectionOptionsInput!
  ) {
    serialBlocks (
      first: $limit
      after: $offset
      options: $options
    ) {
      edges {
        cursor
        node {
          id
          prefix
          status
          startNumber
          quantity
          endNumber
          availableQuantity
          nextNumber
        }
      }
      totalCount
    }
  }
`;


